import { createContext, PropsWithChildren, useState } from "react";
import { ItemType } from "../utils";

type DispatchSetStateAction<T> = React.Dispatch<React.SetStateAction<T>>;

type FilterType = {
    account_number: boolean;
    sub_header: boolean;
    zero_value: boolean;
    date: string;
};

export const ListContext = createContext<{
    item: ItemType[];
    setData: DispatchSetStateAction<ItemType[]>;
    setFilter: DispatchSetStateAction<FilterType>;
    filter: FilterType;
}>({
    item: [],
    setData: () => {},
    setFilter: () => {},
    filter: { account_number: true, sub_header: true, zero_value: true, date: "" },
});

export function ListProvider({ children }: PropsWithChildren) {
    const [item, setData] = useState<ItemType[]>([]);
    const [filter, setFilter] = useState<FilterType>({
        account_number: true,
        sub_header: true,
        zero_value: true,
        date: "",
    });

    return (
        <ListContext.Provider value={{ item, setData, setFilter, filter }}>
            {children}
        </ListContext.Provider>
    );
}
